import React from 'react';
import Header from "../../Header/Header";
import { headerObjThirteen } from "../../Header/HeaderData";

function Sponsorships() {
  return (
    <>
      <Header {...headerObjThirteen} />
      <div className="board-category5">
        <div className="category-title">Coming Soon</div>
      </div>
    </>
  );
}

export default Sponsorships;